import { render } from "./sustainable_social_impact_note.html?vue&type=template&id=54f352c8&external"
import script from "./sustainable_social_impact_note.js?vue&type=script&lang=js&external"
export * from "./sustainable_social_impact_note.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__